export default () => ({
  el: undefined,
  init() {
    mrp.log(`RxDataGridFilter init`);
    this.el = this.$el;
  },
  change() {
    const gridId = this.el.getAttribute("data-grid-id");
    const executeRequired = document.getElementById(
      `${gridId}-filter-execute-required`
    );
    executeRequired.classList.remove("hidden");
  },
  remove() {
    const gridId = this.el.getAttribute("data-grid-id");
    const executeFilters = document.getElementById(`${gridId}-execute-filters`);
    this.change();
    this.el.remove();
    executeFilters.focus();
  },
});
